module.exports = __webpack_public_path__ + "assets/img/map_track.5e49fa0f.png";